// Be careful about applying scripts to the front and back-end.
// WP Admin pages have body.wp-admin (not including the login page which is body.login)

function preloadImages(images, callback) {
    var count = images.length;
    if(count === 0) {
        callback();
    }
    var loaded = 0;
    
    var errorOccured = function() {
        console.warn("Error occured preloading at least 1 image.");
        callback();
        return;
    };

    jQuery(images).each(function() {
        //alert(this.url);
        jQuery('<img>').attr('src', this.url).appendTo('body').css('display','none').load(function() {
            loaded++;
            if (loaded === count) {
                //console.warn('All Images Loaded');
                callback();
                return;
            }
        }).error(function() {
            errorOccured();
        });
    });
}

if(typeof ie_css != 'undefined') {
    //add in a stylesheet if it is ie

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) { //if IE then insert stylesheet
        var css = ie_css.style_string,
        head = document.head || document.getElementsByTagName('head')[0],
        style = document.createElement('style');
        //console.log('loaded ie extra styles', css);
        style.type = 'text/css';
        if (style.styleSheet){
          // This is required for IE8 and below.
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
        head.appendChild(style);
    }
}

if(typeof ts_required_images != "undefined") {

    //console.log('Required Images', ts_required_images.images);
    if(typeof ts_required_images.images.start !== "undefined" && ts_required_images.images.start.length > 0) {

        if(ts_required_images.images.start.length == 1) {

            var imageUrl = ts_required_images.images.start[0].url;

            jQuery('<img />').attr('src', imageUrl).appendTo('body').css('display','none').on('load', function(){
                jQuery('body').removeClass('fade-black');
                if(typeof ts_required_images.images.page !== "undefined") {
                    preloadImages(ts_required_images.images.page, function(){

                        if(jQuery('body.archive.tax-ts_project-type').length > 0) {
                            //this code has been moved to theme.js and called when the masonry has been completed for this tax
                            // jQuery('body.tax-ts_project-type .theme-page .project-archive-headers .header').addClass('on-tax-page');
                            // jQuery('body').addClass('show-back-button');
                            // jQuery('body').removeClass('doing-turbo');
                            // jQuery('html').removeClass('doing-turbo');
                        } else {
                            jQuery('body.tax-ts_project-type .theme-page .project-archive-headers .header').addClass('on-tax-page');
                            jQuery('body').addClass('show-back-button');
                            jQuery('body').removeClass('doing-turbo');
                            jQuery('html').removeClass('doing-turbo');
                        }
                    });
                } else {
                    jQuery('body').removeClass('fade-black');
                }

            }).on("error", function(){

                // If the header image failed to load, the user will be left with a black screen, silently allow them to continue.

                jQuery('body').removeClass('fade-black');

                preloadImages(ts_required_images.images.page, function () {

                    if (jQuery('body.archive.tax-ts_project-type').length > 0) {
                        //this code has been moved to theme.js and called when the masonry has been completed for this tax
                        // jQuery('body.tax-ts_project-type .theme-page .project-archive-headers .header').addClass('on-tax-page');
                        // jQuery('body').addClass('show-back-button');
                        // jQuery('body').removeClass('doing-turbo');
                        // jQuery('html').removeClass('doing-turbo');
                    } else {
                        jQuery('body.tax-ts_project-type .theme-page .project-archive-headers .header').addClass('on-tax-page');
                        jQuery('body').addClass('show-back-button');
                        jQuery('body').removeClass('doing-turbo');
                        jQuery('html').removeClass('doing-turbo');
                    }
                });
            });
        } else if (ts_required_images.images.start.length > 1) { //the homepage

            preloadImages(ts_required_images.images.start, function(){
                jQuery('body.page-template-homepage').addClass('homepage-loaded');
            });
        }

    } else {
        if(typeof ts_required_images.images.page !== "undefined") {

            console.log("ts required images page");

            preloadImages(ts_required_images.images.page, function(){
                jQuery('body').removeClass('fade-black');
                jQuery('body').removeClass('doing-turbo');
                jQuery('html').removeClass('doing-turbo');
                jQuery('body').addClass('show-back-button');

            });
        } else {
            jQuery('body').removeClass('fade-black');
            jQuery('body').removeClass('doing-turbo');
        }
    }

} else {
    //no required images
    jQuery('body').removeClass('fade-black');
    jQuery('body').removeClass('doing-turbo');
    jQuery('body').addClass('show-back-button');
}

if(typeof homepage_menu !== "undefined" && typeof homepage_menu.number !== "undefined") {
    jQuery('body.page-template-homepage').removeClass('homepage-menu-items-transitioned');
    setTimeout(function(){
        jQuery('body.page-template-homepage').addClass('homepage-loaded');
    }, 250);
    setTimeout(function(){
        jQuery('body.page-template-homepage').addClass('homepage-menu-items-transitioned');
    }, 3000);
}
